// extracted by mini-css-extract-plugin
export default {"flex":"style_flex__0LIGM","downloadIcon":"style_downloadIcon__wAYyA","filename":"style_filename__uhK72","video":"style_video__tBecn"};